import { useCallback, useMemo } from 'react';
import { Vector2, Vector3 } from 'three';

import { assertNever } from '@/helpers/utils';
import {
  ITpsService,
  TpsServiceFactory,
} from '@/modules/templating';
import { AppServiceFactory } from '@/modules/app/service/AppServiceFactory';

export const useTemplateClick = () => {
  const appSvc = useMemo(() => AppServiceFactory.getInstance().createAppService(), []);

  const templateClick = useCallback(
    async (position: Vector3, templateType: 'LASSIE' | 'LASSIE_MINI' | 'SHUTTLE' | 'HIK') => {
      appSvc.showLoadContainer('TRANSPARENT');

      const tpsSvc: ITpsService = TpsServiceFactory.getInstance().createTpsService();

      switch (templateType) {
        case 'LASSIE':
          await tpsSvc.generateLassieTemplate(new Vector2(position.x, position.y));
          break;
        case 'LASSIE_MINI':
          await tpsSvc.generateLassieMiniTemplate(new Vector2(position.x, position.y));
          break;
        case 'HIK':
          await tpsSvc.generateHikTemplate(new Vector2(position.x, position.y));
          break;
        case 'SHUTTLE': {
          await tpsSvc.generateShuttleTemplate(new Vector2(position.x, position.y));
          break;
        }
        default:
          assertNever(templateType);
      }

      appSvc.hideLoadContainer();
    },
    [appSvc],
  );

  return { templateClick };
};
